<template>
  <div class="event-playlist__toolbar mb-8 flex flex-col md:flex-row items-baseline">
    <div class="mb-6 md:mb-0 flex flex-1 text-gray-700">
      <div class="hidden ml-2 mr-10 sm:inline-flex w-10 h-10 bg-pink-100 rounded-full text-align items-center justify-center">
        <mj-icon
          src="settings"
          class="w-4 h-4 fill-current text-pink-500 "
        />
      </div>
      <div class="event-playlist__filter flex flex-row">
        <button
          v-for="(filter, i) in filters"
          :key="i"
          class="event-playlist__filter-item mr-6 text-sm focus:outline-none"
          :class="{'text-pink-500' : filter.key === activeFilter}"
          @click="onActivateFilter(filter)"
        >
          {{ filter.label }}
          <span
            class="event-playlist__filter-badge"
            :class="{'event-playlist__filter-badge--is-active' : filter.key === activeFilter}"
          >{{ getFilterLength(filter.key) }}</span>
        </button>
      </div>
    </div>
    <div class="event-playlist__actions w-full">
      <div>
        <mj-button
          class="btn-primary w-full flex justify-center"
          :is-busy="isGuestTrackSyncingBusy"
          @click="onSyncAllGuestTracks"
        >
          Alle Gäste Tracks synchronisieren
        </mj-button>
      </div>
      <div>
        <small class="text-gray-700 text-xs">
          Einzelne Gäste Tracks müssen von dir manuell über das <mj-icon
            src="like"
            class="w-3 h-3 fill-current text-pink-500"
          /> Icon mit Spotify synchronisiert werden.
        </small>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'EventPlaylistToolbar',

  props: {
    filters: {
      type: Array,
      required: true,
    },

    activeFilter: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: true,
    },

    tracks: {
      type: Array,
      required: true,
    },

    isGuestTrackSyncingBusy: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {

    onActivateFilter(filter) {
      this.$emit('activated', filter);
    },

    onSyncAllGuestTracks() {
      this.$emit('sync-all-guest-tracks');
    },

    getFilterLength(key) {
      if (key === null) {
        return this.tracks.length;
      }
      return this.tracks.filter(track => track.trackable_type === key).length;
    },

  },

};

</script>

<style lang="scss" scoped>
.event-playlist {

  &__filter {

    &-badge {
      @apply inline-flex;
      @apply h-5;
      @apply w-5;
      @apply bg-gray-100;
      @apply text-gray-700;
      font-size: .65rem;
      @apply text-center;
      @apply rounded-full;
      @apply items-center;
      @apply justify-center;

      &--is-active {
        @apply bg-pink-100;
        @apply text-pink-500;
      }
    }

  }

  &__actions {
    @screen md {
      max-width: 16rem;
    }

    @screen lg {
      max-width: 20rem;
    }
  }
}
</style>
